import React, { useEffect, useState } from "react"
import Header from "../../template/Header"
import { Breadcrumbs, Card, IconButton, LinearProgress, Tooltip, Typography } from "@mui/material"
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import APIInvoke from "../../utils/APIInvoke"
import { useParams } from "react-router-dom";
import { setLoading } from "../../template/app-actions";
import toast from "react-hot-toast";
import { datetimeToLocalFull } from "../../utils/DateUtilsUTC";
import ListAltIcon from '@mui/icons-material/ListAlt';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ConfirmDialog from "../../template/ConfirmDialog";
import { Editor } from '@monaco-editor/react';

import InfiniteScroll from 'react-infinite-scroll-component';

const DocumentTransaction = () => {

    const { project, transactionId } = useParams()
    const [state, setState] = useState({
        items: [],
        totalItems: 0,
        currentPage: -1,
        totalPages: 1,
        pageSize: 20,
    })
    const [showDocumentPreviewDialog, setShowDocumentPreviewDialog] = useState({
        open: false,
        revision: null
    })

    useEffect(() => {
        fetchTransaction()
    }, [project, transactionId])

    const fetchTransaction = async () => {
        try {
            setLoading(true)
            if(state.currentPage >= state.totalPages - 1) return;
            const response = await (await APIInvoke.invokeGET(`/projects/${project}/documents/transactions/${transactionId}?page=${state.currentPage + 1}&size=${state.pageSize}`)).json()
            setState({
                ...state,
                items: [...state.items, ...response.body.items],
                totalItems: response.body.totalItems,
                currentPage: response.body.currentPage,
                totalPages: response.body.totalPages,
            })
        } catch (error) {
            toast.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="timeline">
            <ConfirmDialog color="green" title="Document preview" message="" open={showDocumentPreviewDialog.open} onClose={() => setShowDocumentPreviewDialog({ ...showDocumentPreviewDialog, open: false, revision: null })}>
                <Editor
                    required
                    options={{
                        selectOnLineNumbers: true,
                        automaticLayout: true,
                        minimap: {
                            enabled: false
                        },
                        lineNumbers: 'on',
                        scrollbar: {
                            vertical: 'auto',
                            horizontal: "auto",
                        },
                        ariaLabel: 'required',
                        placeholder: '$.field',
                        readOnly: true
                    }}
                    width="600px"
                    height="500px"
                    language="json"
                    defaultLanguage="json"
                    theme="light"
                    className="h-full"
                    value={JSON.stringify(showDocumentPreviewDialog.revision?.payload, null, 2) || ""}
                />
            </ConfirmDialog>
            <Header title={<span className="capitalize" >Transaction {transactionId}</span>} >
                <Breadcrumbs aria-label="breadcrumb" separator="/" className="!text-gray-600">
                    <Typography ><HomeOutlinedIcon className="text-gray-600" fontSize="small" /></Typography>
                    <Typography ><span className="text-gray-600">Transactions</span></Typography>
                    <Typography ><span className="text-gray-600">{transactionId}</span></Typography>
                </Breadcrumbs>
            </Header>
            <div className="content grid gap-8">

                <InfiniteScroll
                    dataLength={state.items.length} //This is important field to render the next data
                    next={fetchTransaction}
                    hasMore={state.currentPage + 1 < state.totalPages}
                    loader={(
                        <LinearProgress size="sm" >
                            <span>Loading...</span>
                        </LinearProgress>
                    )}
                    endMessage={
                        <p style={{ textAlign: 'center' }}>
                            <b>No more revisions</b>
                        </p>
                    }
                >
                    {state.items.map((revision, idx) => (
                        <div key={idx}>
                            <div className="h-full relative flex items-start justify-start gap-4">
                                <div className="h-full relative flex flex-col items-end">
                                    <p className="text-sm text-dark-700 m-0 p-0">{datetimeToLocalFull(revision.createAt)}</p>
                                    <p className="text-sm text-dark-300 m-0 p-0">{idx + 1} of {state.totalItems}</p>
                                </div>
                                <div className="relative flex flex-row items-start gap-4">
                                    {idx < state.items.length - 1 && (
                                        <div className="bg-dark-200 w-1 absolute top-[45px] bottom-[5px] left-[18px] rounded-full " />
                                    )}
                                    <div className="z-10 p-2 rounded-full bg-green-500 flex items-center justify-center">
                                        <ListAltIcon className="text-white !p-0 !m-0" />
                                    </div>
                                    <div className="flex flex-row gap-4">
                                        <Card className="mb-8 min-w-[500px] flex-1">
                                            <div className="bg-gray-500 p-4 border-b border-gray-400">
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center gap-2">
                                                        <Tooltip title="Collection">
                                                            <p>{revision.collection}</p>
                                                        </Tooltip>
                                                        <Tooltip title="Key">
                                                            <p>- {revision.key}</p>
                                                        </Tooltip>
                                                    </div>
                                                    <Tooltip title="Revision">
                                                        <p>v{revision.revision}</p>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div className="p-2">
                                                <p className="text-sm">Created By: {revision.createBy}</p>
                                                <p className="text-sm">TransactionId: {revision.transactionId}</p>
                                                <p className="text-sm">Action: {revision.action}</p>
                                            </div>
                                        </Card>
                                        <div className="flex flex-col gap-2">
                                            {/* 
                                            <Tooltip title="Go to document">
                                                <IconButton variant="contained" className="!bg-green-500 hover:!bg-green-600 !rounded-md" LinkComponent={Link} to={`/projects/${project}/collections/${revision.collection}/documents/${revision.id}`}>
                                                    <LaunchIcon fontSize="small" className="text-white" />
                                                </IconButton>
                                            </Tooltip>
                                            */}
                                            <Tooltip title="Preview payload">
                                                <IconButton variant="contained" className="!bg-green-500 hover:!bg-green-600 !rounded-md" onClick={() => setShowDocumentPreviewDialog({ ...showDocumentPreviewDialog, open: true, revision: revision })}>
                                                    <VisibilityIcon fontSize="small" className="text-white" />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </InfiniteScroll>
            </div>
        </div>
    )
}

export default DocumentTransaction  